var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9e1e8;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wind"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.5,25A4.51,4.51,0,0,1,21,20.5V20a1,1,0,0,1,2,0v.5A2.5,2.5,0,1,0,25.5,18H3a1,1,0,0,1,0-2H25.5a4.5,4.5,0,0,1,0,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20,15H6a1,1,0,0,1,0-2H20a2,2,0,1,0-2-2,1,1,0,0,1-2,0,4,4,0,1,1,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,27a4,4,0,0,1-4-4,1,1,0,0,1,2,0,2,2,0,1,0,2-2H6a1,1,0,0,1,0-2H16a4,4,0,0,1,0,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,12H9a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.a4d054638077292c04aee3dc54afe574.svg";
export { ForwardRef as ReactComponent };